/* eslint typescript-sort-keys/string-enum: 2 */

import { MouseEvent, KeyboardEvent } from 'react';

export enum Dialog {
  ActivateEmailMFA = 'activateEmailMFA',
  ActivateSMSMFA = 'activateSMSMFA',
  ActivateTOTP = 'activateTOTP',
  ActivateUserMFA = 'activateUserMFA',
  ActivityTypesEditor = 'activityTypesEditor',
  AddExternalParty = 'addExternalParty',
  AddFavouriteReport = 'addFavouriteReport',
  AddFormulaField = 'addFormulaField',
  AddInvoiceForProject = 'addInvoiceForProject',
  AddMaterials = 'AddMaterials',
  AddProject = 'addProject',
  BillingSettings = 'billingSettings',
  BookkeepingEmails = 'bookkeepingEmails',
  BulkTimeTracking = 'bulkTimeTracking',
  BulkTimeTrackingFromPlanning = 'bulkTimeTrackingFromPlanning',
  BulkUpdateProjectLineAssignees = 'bulkUpdateProjectLineAssignees',
  BulkUpdateProjectLineGroup = 'bulkUpdateProjectLineGroup',
  BulkUpdateProjectLineStatus = 'bulkUpdateProjectLineStatus',
  BulkUpdateProjectLinesResult = 'bulkUpdateProjectLinesResult',
  CallMarkAsDone = 'callMarkAsDone',
  CallMarkedAsDone = 'callMarkedAsDone',
  CallsDetail = 'callsDetail',
  ChangeCustomerAvatar = 'changeCustomerAvatar',
  ChangeGroupBudget = 'changeGroupBudget',
  ChangeProjectBudget = 'changeProjectBudget',
  ChangeTrialFeatures = 'changeTrialFeatures',
  ChooseExistingQuotation = 'chooseExistingQuotation',
  CloseProjectConfirmation = 'closeProjectConfirmation',
  CompanyAddRelatedCompany = 'companyAddRelatedCompany',
  CompanyAddRelatedContact = 'companyAddRelatedContact',
  CompanyEntityArchive = 'companyEntityArchive',
  CompanyEntityEditor = 'companyEntityEditor',
  CompanyEntityTermsAndConditions = 'CompanyEntityTermsAndConditions',
  CompanyInformation = 'companyInformation',
  CompanyMergeCompany = 'companyMergeCompany',
  ContactInformation = 'contactInformation',
  ConvertToProject = 'convertToProject',
  CreateInvoicesForProjects = 'createInvoicesForProjects',
  CreateProjectCloudLink = 'createProjectCloudLink',
  CreditNoteEmailEditor = 'creditNoteEmailEditor',
  CreditNoteExportCSV = 'creditNoteExportCSV',
  CreditNoteExportExcel = 'creditNoteExportExcel',
  CreditNotePostalEditor = 'creditNotePostalEditor',
  CreditNoteSend = 'creditNoteSend',
  CustomerDownloadLabels = 'customerDownloadLabels',
  CustomerGenerateReport = 'customerGenerateReport',
  CustomerInvoicingPreferencesEdit = 'customerInvoicingPreferencesEdit',
  DeactivateCustomer = 'deactivateCustomer',
  DeactivateMFA = 'deactivateMFA',
  DeactivateUserMFA = 'deactivateUserMFA',
  DealPhase = 'DealPhase',
  DealPhaseDelete = 'dealPhaseDelete',
  DealPipeline = 'dealPipeline',
  DefaultLedgerAccountsVAT = 'defaultLedgerAccountsVAT',
  DeleteDealPipeline = 'deleteDealPipeline',
  DeleteExternalParty = 'deleteExternalParty',
  DeleteGroup = 'deleteGroup',
  DeleteInsightsReport = 'deleteInsightsReport',
  DeleteMaterial = 'deleteMaterial',
  DeleteMeeting = 'deleteMeeting',
  DeleteProjectConfirmation = 'deleteProjectConfirmation',
  DeleteProjectFilter = 'deleteProjectFilter',
  DeleteProjectLines = 'deleteProjectLines',
  DeleteTask = 'deleteTask',
  DeleteUser = 'deleteUser',
  DownloadProjectReport = 'downloadProjectReport',
  EditCustomerMeetingRights = 'editCustomerMeetingRights',
  EditFormulaField = 'editFormulaField',
  EmailLinkDialog = 'emailLinkDialog',
  ExportProjects = 'exportProjects',
  FileManager = 'fileManager',
  FilePreview = 'filePreview',
  FileUpload = 'fileUpload',
  GrantAdministratorPermissions = 'grantAdministratorPermissions',
  GroupBillingMethodChange = 'groupBillingMethodChange',
  InsightsAdvancedInsightsOnboardingDialog = 'insightsAdvancedInsightsOnboardingDialog',
  InsightsSaveAsNewReport = 'insightsSaveAsNewReport',
  InsightsUpsellDialog = 'insightsUpsellDialog',
  InviteUser = 'inviteUser',
  InvoiceEmailEditor = 'invoiceEmailEditor',
  InvoiceExportCSV = 'invoiceExportCSV',
  InvoiceExportExcel = 'invoiceExportExcel',
  InvoicePaid = 'invoicePaid',
  InvoicePeppolSend = 'invoicePeppolSend',
  InvoicePostalEditor = 'invoicePostalEditor',
  InvoiceSend = 'invoiceSend',
  LegacyListViewColumnManager = 'legacyListViewColumnManager',
  ListViewColumnManager = 'listViewColumnManager',
  ManageHolidaysExternally = 'manageHolidaysExternally',
  MaterialProductChange = 'materialProductChange',
  MeetingAddContact = 'MeetingAddContact',
  MeetingTimetracking = 'meetingTimetracking',
  MoveProjectLineConfirmation = 'moveProjectLineConfirmation',
  MultipleCompanyEntitiesUpsell = 'multipleCompanyEntitiesUpsell',
  MultipleDealPipelinesUpsell = 'multipleDealPipelinesUpsell',
  NotEnoughScansDialog = 'notEnoughScansDialog',
  PaymentMethodsEditor = 'paymentMethodsEditor',
  PaymentTerm = 'paymentTerm',
  PermissionDependency = 'permissionDependency',
  PlanningOverplanConfirmation = 'planningOverplanConfirmation',
  PlanningPreferences = 'planningPreferences',
  PlanningPreview = 'planningPreview',
  PrepaidWarningDialog = 'prepaidWarningDialog',
  ProjectBillingMethodChange = 'projectBillingMethodChange',
  ProjectCustomUserRates = 'projectCustomUserRates',
  ProjectEndDateChange = 'projectEndDateChange',
  ProjectExportTimesheet = 'projectExportTimesheet',
  ProjectGroupEndDateChange = 'projectGroupEndDateChange',
  ProjectGroupStartDateChange = 'projectGroupStartDateChange',
  ProjectPreferences = 'projectPreferences',
  ProjectStartDateChange = 'projectStartDateChange',
  ProjectTemplateColumnManager = 'projectTemplateColumnManager',
  ProjectsBillingMethodPreferences = 'projectsBillingMethodPreferences',
  ProjectsUpsell = 'projectsUpsell',
  QuotationPreviewDialog = 'quotationPreviewDialog',
  QuotationRename = 'quotationRename',
  QuotationsSend = 'quotationsSend',
  ReactivateCustomer = 'reactivateCustomer',
  RemoveProjectAsTemplate = 'removeProjectAsTemplate',
  RemoveProjectCustomerConfirmation = 'removeProjectCustomerConfirmation',
  ReopenProjectConfirmation = 'reopenProjectConfirmation',
  RevokeAdministratorPermissions = 'revokeAdministratorPermissions',
  SaveProjectAsTemplate = 'saveProjectAsTemplate',
  SelectCustomerForProjectInvoice = 'selectCustomerForProjectInvoice',
  ShareReportInternally = 'shareReportInternally',
  SingleTimeTracking = 'singleTimeTracking',
  TaskMarkedAsDone = 'taskMarkedAsDone',
  TemplateColumnManager = 'templateColumnManager',
  UnlimitedDealPipelinesUpsell = 'unlimitedDealPipelinesUpsell',
  UnlinkDealFromProject = 'unlinkDealFromProject',
  UpdateParentBudget = 'updateParentBudget',
  UpdateProjectCustomerConfirmation = 'updateProjectCustomerConfirmation',
  UploadPlaceholderDocuments = 'uploadPlaceholderDocuments',
  UserPermissionsDialog = 'viewUserPermissions',
  WhiteLabeledDomainAdd = 'whiteLabeledDomainAdd',
  WhiteLabeledDomainRecords = 'whiteLabeledDomainRecords',
}

export interface DialogPropMap extends Record<Dialog, unknown> {}

interface AutomaticallyAddedProps {
  onClose: (event?: MouseEvent | KeyboardEvent) => void;
}

export type DialogProps<T = {}> = AutomaticallyAddedProps & T;

export type AddDialogProps<T extends unknown = {}> = Omit<DialogProps<T>, keyof AutomaticallyAddedProps> &
  Partial<AutomaticallyAddedProps>;

export type StoredDialog = {
  props: AddDialogProps;
  type: Dialog;
};
